export default "__VITE_ASSET__C0Dmi$nQ__"